export const VIBE_CODEX_GUIDE_SCENE = {
    NORMAL: 'normal',
    APPLICATION_SUBMITTED: 'applicationSubmitted',
}

export const normalizePromptText = text => {
    if (!text) return ''
    return String(text)
        .replace(/\\r\\n/g, '\n')
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '\n')
}

export const getMissingProjectNames = projects => (Array.isArray(projects) ? projects : [])
    .map(item => item?.projectName || item?.projectSlug || item?.mysqlDatabaseName || item?.projectId)
    .filter(Boolean)
    .map(String)

export const normalizeVibeCodexGuideResponse = response => ({
    prompt: normalizePromptText(response?.prompt || ''),
    promptVersion: response?.promptVersion || '',
    scopeType: response?.scopeType || '',
    authorizedProjectCount: Number(response?.authorizedProjectCount) || 0,
    missingProjectNames: getMissingProjectNames(response?.missingDictionaryProjects),
    customPromptApplied: !!response?.customPromptApplied,
})

export const getVibeCodexGuideSceneMessage = scene => (
    scene === VIBE_CODEX_GUIDE_SCENE.APPLICATION_SUBMITTED
        ? '申请已提交。项目所有者同意后你才能查询该项目；审批通过后，请让 Codex 强制刷新数据字典，以更新可查询的项目范围。'
        : ''
)
